import { Service } from '@tino-frontend/adapters'
import {
  CreatePaymentLinkPayload,
  ListPaymentLinksResponse,
  ValidatePaymentLinkPayload,
  PaymentLinkDetail,
  ValidatePaymentLinkResponse,
  ListPaymentLinksPayload,
  PurchaseIntentionResponse,
} from '@types'

export class PaymentLinkService {
  constructor(private readonly http: Service) {}

  create(
    payload: CreatePaymentLinkPayload
  ): Promise<PurchaseIntentionResponse> {
    return this.http.post('/v1/payment-links', payload)
  }

  validate(
    payload: ValidatePaymentLinkPayload
  ): Promise<ValidatePaymentLinkResponse> {
    return this.http.post('/v1/payment-links/validate', payload)
  }

  list(params: ListPaymentLinksPayload): Promise<ListPaymentLinksResponse> {
    return this.http.get('/v1/payment-links', {
      params,
    })
  }

  getDetail(id: string): Promise<PaymentLinkDetail> {
    return this.http.get(`/v1/payment-links/${id}`)
  }

  resend({
    purchaseIntentionId,
    supplierCompanyId,
  }: {
    purchaseIntentionId: string
    supplierCompanyId: string
  }) {
    return this.http.post(
      `/v1/payment-links/${purchaseIntentionId}/resend?supplier_company_id=${supplierCompanyId}`
    )
  }
}
